export default "__VITE_ASSET__8a8c51f5__"